import React from "react";
import { useSegmentCallbackV2 } from "../src/segment";

interface UtmParams {
  source?: string;
  content?: string;
}

const createUTM = (params: UtmParams) => {
  let utmSource: string | null = null;
  let utmContent: string | null = null;

  if (params.source) {
    utmSource = `utm_source=${params.source}`;
  }
  if (params.content) {
    utmContent = `utm_content=${params.content}`;
  }

  // Join all set parameters.
  let utmString = [utmSource, utmContent].filter(Boolean).join("&");

  // Format the UTM string
  if (utmString) {
    utmString = `?${utmString}`;
  }

  return utmString;
};

const Schedule1x1Cta: React.FC<
  React.PropsWithChildren<{
    utmContent: string;
    utmSource: string;
    className?: string;
  }>
> = ({ utmContent, utmSource, className, children }) => {
  const segmentTrack = useSegmentCallbackV2();

  let ctaUrl = "https://www.osohq.com/meet-eng";
  // Create a UTM string to append to the CTA URL
  const utmString = createUTM({ source: utmSource, content: utmContent });
  ctaUrl = `${ctaUrl}${utmString}`;

  return (
    <a
      href={ctaUrl}
      className={className}
      target="_blank"
      rel="noreferrer"
      onClick={() =>
        segmentTrack("Schedule 1x1 CTA", {
          utm_content: utmContent,
          utm_source: utmSource,
        })
      }
    >
      {children}
    </a>
  );
};

export default Schedule1x1Cta;
